export default ".vjs-picture-in-picture-control {\n  display: none;\n}";